var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"home-scroll-invitation",class:{hidden: _vm.hidden}},[_c('div',{staticClass:"home-scroll-invitation-dots-container"},_vm._l((4),function(i){return _c('div',{key:i,ref:"dots",refInFor:true,staticClass:"home-scroll-invitation-dot",style:(`transition-delay: ${i * .03}s`)})}),0)])
}
var staticRenderFns = []

export { render, staticRenderFns }